﻿import objectToQueryString from "./objectToQueryString";

/**
 * Appends query parameters to a URL.
 * @param url The base URL to append parameters to.
 * @param queryObject An object containing query parameters (undefined values are excluded).
 * @returns The URL with appended query parameters, using '?' or '&' as appropriate. An object
 *          whose values are all undefined leaves the url untouched — no trailing '?'.
 */
export default function addQueryObject(url: string, queryObject: Record<string, string | undefined> | undefined): string {
	const query = objectToQueryString(queryObject);
	if (!query) {
		return url;
	}
	return url + (url.includes("?") ? "&" : "?") + query;
}
